"use client";

import styles from "./TermsModalLink.module.css";
import { PropsWithChildren, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Modal } from "antd";
import TermsContent from "./TermsContent";

type TermsModalLinkProps = PropsWithChildren<{
  className?: string;
}>;

export default function TermsModalLink({
  className = "",
  children,
}: TermsModalLinkProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`${styles.trigger} ${className}`.trim()}
        onClick={() => setOpen(true)}
      >
        {children ?? <FormattedMessage id="footer-terms" />}
      </button>

      <Modal
        title={<FormattedMessage id="footer-terms" />}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        destroyOnClose
        width={840}
      >
        <div className={styles.modalBody}>
          <TermsContent />
        </div>
      </Modal>
    </>
  );
}
